/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useCallback, useContext, memo } from 'react';

import initialActions from './actions';

import { IState, IActions } from './dtos';

import { initialState } from './constants';

interface IData {
  data: IState;
  actions: IActions;
}

export const SpecSheetModalContext = React.createContext<IData>({
  data: initialState,
  actions: initialActions({ data: initialState, setData: () => {} }),
});

export const useSpecSheetModal = (): IData => useContext(SpecSheetModalContext);

export default function withSpecSheetModalProvider(
  WrappedComponent: React.FC,
  state: IState = initialState,
  actions = initialActions,
): React.FC {
  const WithSpecSheet = (props: any) => {
    const [data, setData] = useState(state);

    const value = useCallback(
      () => ({
        data,
        actions: actions({ data, setData }),
      }),
      [data],
    );

    const dataValue: IData = value();

    return (
      <SpecSheetModalContext.Provider value={dataValue}>
        <WrappedComponent {...props} />
      </SpecSheetModalContext.Provider>
    );
  };

  return memo(WithSpecSheet);
}
